import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import html2pdf from "html2pdf.js";
import commonLabels from "../../../common/labels/common_en.json";
import label from "../../labels/postExaminationProcessObjective_en.json";
import {
    getAdvertisementsList,
    getExamslistByAdvertisementId,
    getSubjectlistByExamId,
    getAbsenteeListByAdvtIdAndExamId,
} from "../../actions/postExaminationProcessObjectiveActions";
import { getYearList, getAdvertisementlistByYear } from "../../../common/actions/commonActions";
import { GET_ABSENTEE_LIST } from "../../../common/constants/ActionTypes";

const AbsentListDescriptive = () => {
    const pdfRef = useRef(null);

    const { register, handleSubmit, errors } = useForm({
        mode: "onChange",
    });

    let { examList, advertisementList, subjectList, abseenteeList } =
        useSelector((state) => state.postExamProcessObjectReducer, shallowEqual);


    let { yearList, allYearList } = useSelector(
        (state) => state.common,
        shallowEqual
    );


    const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
    const [selectedExam, setSelectedExam] = useState("");
    const [selectedSubject, setSelectedSubject] = useState("");
    const [reloadItem, setReloadItem] = useState(true);
    const [saveButtonFlag, setSaveButtonFlag] = useState(true);
    const [confirmClicked, setConfirmClicked] = useState(false);
    const [printFlag, setPrintFlag] = useState(true);
    const [absentDtos, setAbsentDtos] = useState([]);
    const session = JSON.parse(sessionStorage.getItem("session"));
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getYearList());
        window.scrollTo(0, 0)
        setReloadItem(!reloadItem);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (abseenteeList.absentDtos) {
            setAbsentDtos(abseenteeList.absentDtos);
        }
    }, [abseenteeList.absentDtos]);

    useEffect(() => {
        setPrintFlag(absentDtos.length === 0);
    }, [absentDtos.length, setPrintFlag]);

    const onAdvertisementChange = (ele) => {
        setSelectedAdvertNo(ele);
        setSelectedExam("");
        setSelectedSubject("");
        setSaveButtonFlag(true);
        setConfirmClicked(false);
        setPrintFlag(true);
        examList.length =
            subjectList.length =
            absentDtos.length =
            0;
        ele && dispatch(getExamslistByAdvertisementId(ele));
        setReloadItem(!reloadItem);
    };


    const onSelectYear = (ele) => {
        if (ele == "") {
            onCancelButton()
        } else {

            let selectedValue = ele;
            selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
            allYearList.length = 0;
            if (examList) {
                examList.length = 0;
            }
            if (subjectList) {
                subjectList.length = 0;
            }
            setSaveButtonFlag(true);
            setConfirmClicked(false);
            setReloadItem(!reloadItem);
            dispatch({
                type: GET_ABSENTEE_LIST,
                payload: []
            })
        }
    };
    const onExamChange = (ele) => {
        setSelectedExam(ele);
        setSelectedSubject("");
        setSaveButtonFlag(true);
        setConfirmClicked(false);
        setPrintFlag(true);
        subjectList.length = absentDtos.length = 0;
        ele && dispatch(getSubjectlistByExamId(ele));
        setReloadItem(!reloadItem);
    };

    const onSubjectChange = (ele) => {
        setSelectedSubject(ele);
        setSaveButtonFlag(false);
        setConfirmClicked(false);
        setPrintFlag(true);
        absentDtos.length = 0;
        setReloadItem(!reloadItem);
    };

    const onCancelButton = () => {
        setSelectedAdvertNo("");
        setSelectedExam("");
        setSelectedSubject("");
        setSaveButtonFlag(true);
        setConfirmClicked(false);
        setPrintFlag(true);
        setReloadItem(!reloadItem);
        absentDtos.length =
            allYearList.length =
            examList.length =
            subjectList.length =
            0;
    };

    const onSubmit = () => {
        dispatch(getAbsenteeListByAdvtIdAndExamId(
            selectedAdvertNo,
            selectedExam,
            selectedSubject
        ));
        setReloadItem(!reloadItem);
    };

    const genPdf = () => {
        let headerDiv = ' <div class="row d-flex flex-column align-items-center"><h5 class="bold-label">' + label.MPSC + '</h5><h5>' + abseenteeList.examName + '</h5><h5>' + label.AbsenteeReport + '</h5><h5>' + abseenteeList.subjectName + '</h5></div>';
        const htmlContent = document.createElement("div");
        htmlContent.innerHTML = headerDiv;
        htmlContent.innerHTML += pdfRef.current.innerHTML;
        const examName = abseenteeList.examName;
        const subjectName = abseenteeList.examName;

        const options = {
            margin: [0.8, 0.4, 0.8, 0.4],
            filename: "absentList.pdf",
            image: { type: "jpeg", quality: 0.95 },
            html2canvas: { scale: 3, dpi: 300, letterRendering: true },
            jsPDF: {
                unit: "in",
                format: "a4",
                orientation: "portrait",
                compressPDF: true,
            },
        };

        html2pdf()
            .from(htmlContent)
            .set(options)
            .toPdf()
            .get("pdf")
            .then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages();

                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);

                    const pageWidth = pdf.internal.pageSize.getWidth();
                    const pageHeight = pdf.internal.pageSize.getHeight();
                    const textWidth =
                        (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
                        pdf.internal.scaleFactor;
                    const textX = pageWidth - textWidth - 1;
                    const textY = 0.8;
                    const currentDate = new Date();
                    const formattedDate = currentDate.toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                    }).split('/').join('/');

                    const dateWidth = pdf.getStringUnitWidth(formattedDate) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
                    const dateX = pageWidth - dateWidth;
                    const dateY = 0.6;
                    pdf.setFontSize(8);
                    pdf.text(formattedDate, dateX, dateY);
                    pdf.text(`Page No. ${i}`, dateX, textY)

                    const ad = abseenteeList.advertisementCode;
                    const headerText = `Advertisement No. ${ad}`;
                    const headerX = 0.4;
                    const headerY = 0.6;

                    pdf.setFontSize(8);
                    pdf.text(headerText, headerX, headerY);
                }

                pdf.save(`absentList_${examName}_${subjectName}.pdf`);
            });
    };

    const downloadPdf = () => {
        genPdf();
        setReloadItem(!reloadItem);
    };

    return (
        <div className="dashboardContentArea">
            <h5> {label.AbsentListDescriptive} </h5>

            <div className="row dashboardCards">
                <div className="col-md-12">
                    <form name="importForm" encType="multipart/form-data">
                        <div className="form-group importFromSection ">
                            {/* <div className="row">
                                <div className="col-md-12">
                                    <h5> {label.AbsentList}</h5>
                                </div>
                            </div> */}
                            <div className="row">
                                <div className="form-group col-md-2">
                                    <label className="float-left">
                                        {commonLabels.selectYear}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedYear"
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                            onSelectYear(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">
                                            {commonLabels.COMBO_SELECT}
                                        </option>
                                        {yearList &&
                                            yearList.length > 0 &&
                                            yearList
                                                .map((element, index) => (
                                                    <option>{element}</option>
                                                    // <option key={index} value={element.id}>
                                                    //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                                    // </option>
                                                ))}
                                    </select>
                                    {_.get("selectedYear.type", errors) ===
                                        "required" && (
                                            <p className="errorText float-left">
                                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                                            </p>
                                        )}
                                </div>
                                <div className="form-group col-md-3">
                                    <label className="float-left">
                                        {commonLabels.SelectAdvertNo}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedAdvertiseNo"
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                            onAdvertisementChange(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">
                                            {commonLabels.COMBO_SELECT}
                                        </option>
                                        {allYearList &&
                                            allYearList.length > 0 &&
                                            allYearList
                                                .filter(
                                                    (element) =>
                                                        element.isDeleted == false &&
                                                        element.isActive === true
                                                )
                                                .map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                                    </option>
                                                ))}
                                    </select>
                                    {_.get("selectedAdvertiseNo.type", errors) ===
                                        "required" && (
                                            <p className="errorText float-left">
                                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                                            </p>
                                        )}
                                </div>

                                <div className="form-group col-md-3">
                                    <label className="float-left">
                                        {label.SelectExam}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedExam"
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                            onExamChange(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">
                                            {commonLabels.COMBO_SELECT}
                                        </option>
                                        {examList &&
                                            examList.length > 0 &&
                                            examList
                                                .filter(
                                                    (element) =>
                                                        element.isDeleted == false &&
                                                        element.isActive === true
                                                )
                                                .map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {element.name}
                                                    </option>
                                                ))}
                                    </select>
                                    {_.get("selectedExam.type", errors) === "required" && (
                                        <p className="errorText float-left">
                                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>

                                <div className="form-group col-md-3">
                                    <label className="float-left">
                                        {label.SelectSubject}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedSubject"
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                            onSubjectChange(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">
                                            {commonLabels.COMBO_SELECT}
                                        </option>
                                        {subjectList &&
                                            subjectList.length > 0 &&
                                            subjectList
                                                .filter(
                                                    (element) =>
                                                        element.isDeleted == false &&
                                                        element.isActive === true
                                                )
                                                .map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {element.name}
                                                    </option>
                                                ))}
                                    </select>
                                    {_.get("selectedSubject.type", errors) === "required" && (
                                        <p className="errorText float-left">
                                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>

                            </div>

                            <div className="row">
                                <div className="form-group col-md-8">
                                    {(session.roleName == 'superadmin' || session.roleName == 'secretary' || session.roleName == 'desk officer') &&
                                        <>      <button
                                            type="reset"
                                            className="btn btn-secondary mr-2"
                                            onClick={() => onCancelButton()}
                                        >
                                            {commonLabels.BUTTON_CANCEL}
                                        </button>

                                            <button
                                                type="submit"
                                                className="btn btn-primary mr-2"
                                                disabled={saveButtonFlag}
                                                onClick={handleSubmit((e) => {
                                                    onSubmit(e);
                                                    setConfirmClicked(true);
                                                })}
                                            >
                                                {commonLabels.BUTTON_VIEW}
                                            </button>
                                        </>}
                                    {(session.roleName == 'superadmin' || session.roleName == 'secretary') && <button
                                        type="button"
                                        className="btn btn-primary mr-2"
                                        disabled={printFlag || !confirmClicked}
                                        onClick={() => {
                                            downloadPdf();
                                        }}
                                    >
                                        {commonLabels.BUTTON_PRINT}
                                    </button>}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            {abseenteeList && abseenteeList.absentDtos?.length > 0 && (
                <div ref={pdfRef} className="answerKeyTable" id="absenteeList">


                    <div className="row ">

                        <div className="col-md-12">

                            {abseenteeList &&
                                abseenteeList.absentDtos &&
                                abseenteeList.absentDtos?.length > 0 &&
                                abseenteeList.absentDtos.map((ele, ind) => {
                                    return (
                                        <div className="centerDataSec" key={ind}>
                                            <strong className="centerName">CENTRE : {ele.centerName}</strong><br /><br />
                                            <strong>ABSENT</strong><br />
                                            <ul className="rollList table-font-12">
                                                {ele && ele.rollNumbers && ele.rollNumbers.length > 0 && ele.rollNumbers.map((rollno, index) => {
                                                    return (<li key={index}>{rollno}</li>)
                                                })}

                                            </ul>
                                            <span className="totalAttendee">Total : {ele && ele.rollNumbers && ele.rollNumbers.length}</span>
                                        </div>
                                    );
                                })}

                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AbsentListDescriptive;
